import ModalEnhanced from 'modal-enhanced-react-native-web';
export default ModalEnhanced;